module.exports = __webpack_public_path__ + "static/media/TS.72506293.webp";